import React from 'react';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import FaSvg from '../../helpers/FaSvg';

const ToggleButton = ({ isOpen }) => {
  return <FaSvg icon={!isOpen ? faAngleDown : faAngleUp} size="1.4rem" color="label" />;
};

export default ToggleButton;
